import { useState } from "react";
import { toast } from "sonner";
import { Mail, MessageSquare, Send } from "lucide-react";
import { api, apiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", f);
      toast.success("Thanks — we'll get back to you soon.");
      setF({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <div className="overline mb-2">Get in touch</div>
      <h1 className="rainbow-text text-4xl tracking-tight mb-3">Contact Faraway Sister Haven</h1>
      <p className="text-sm mb-8 max-w-xl" style={{ color: "var(--ink-soft)" }}>
        Questions, partnership ideas, feedback, or a bug to report? Send us a note — a real human reads every message.
      </p>

      <form onSubmit={submit} className="paper-card p-6 space-y-5" data-testid="contact-form">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="c-name">Your name</Label>
            <Input id="c-name" required value={f.name} onChange={set("name")} data-testid="contact-name" />
          </div>
          <div>
            <Label htmlFor="c-email">Email</Label>
            <Input id="c-email" type="email" required value={f.email} onChange={set("email")} data-testid="contact-email" />
          </div>
        </div>
        <div>
          <Label htmlFor="c-subject">Subject</Label>
          <Input id="c-subject" required value={f.subject} onChange={set("subject")} data-testid="contact-subject" />
        </div>
        <div>
          <Label htmlFor="c-message">Message</Label>
          <Textarea id="c-message" rows={6} required minLength={10} value={f.message} onChange={set("message")} data-testid="contact-message" />
        </div>
        <div className="flex items-center justify-between gap-4 pt-2">
          <div className="text-xs flex items-center gap-4 flex-wrap" style={{ color: "var(--ink-muted)" }}>
            <span className="inline-flex items-center gap-1"><Mail size={12} /> hello@farawaysisterhaven.app</span>
            <span className="inline-flex items-center gap-1"><MessageSquare size={12} /> We reply within 2 business days</span>
          </div>
          <Button type="submit" disabled={sending} className="btn-press btn-rainbow" data-testid="contact-submit">
            <Send size={14} className="mr-1.5" /> {sending ? "Sending…" : "Send message"}
          </Button>
        </div>
      </form>
    </div>
  );
}
